import { makeStyles, Tooltip } from '@material-ui/core';
import { GPSPositionData } from 'doc-mate-store/lib/models/GPSPosition';
import moment from 'moment';
import React from 'react';
import ArrowIcon from './ArrowUp.svg';
type Props = {
  path: GPSPositionData;
  lat: number;
  lng: number;
  map: any;
};

const ArrowMarker: React.FC<Props> = ({ path, map }) => {
  const classes = useStyles();
  const zoom = map.getZoom();

  let scaleX = (zoom * 1.2) / 16.0;
  let scaleY = (zoom * 1.2) / 16.0;
  const transform = [
    'translate(-50%,-50%)',
    `scale(${scaleX},${scaleY})`,
    `rotate(${path.heading || 0}deg)`,
  ];

  const title = (
    <div>
      <div>
        Timestamp:{' '}
        {moment(path.timestamp).format('MMM DD, YYYY hh:mm:ss A (G\\M\\T Z)')}
      </div>
      <div>Heading: {path.heading.toFixed(2)}</div>
      <div>Lat: {path.latitude}</div>
      <div>Lng: {path.longitude}</div>
      <div>Speed: {path.speed.toFixed(2)}</div>
    </div>
  );

  return (
    <div
      className={classes.root}
      style={{
        transform: transform.join(' '),
        transformOrigin: 'center center',
        transformStyle: 'preserve-3d',
      }}
    >
      <Tooltip title={title}>
        <img
          src={ArrowIcon}
          width={24}
          height={24}
          alt="ArrowUp"
          className={classes.icon}
        />
      </Tooltip>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    width: 24,
    height: 24,
  },
  icon: {},
}));

export default ArrowMarker;
